export default __webpack_public_path__ + "static/media/11_alien.9d947f3b.JPG";